import { createAsyncThunk } from "@reduxjs/toolkit";
import { getProjectTaskWithCCF } from "../../../apiConfig/apiCall";

export const getCCFData = createAsyncThunk('getCCFData', async (CLIENT_ID) => {
    const response = await getProjectTaskWithCCF(CLIENT_ID);
    return response.data;
});